import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_NO_DEMO_ILO2 = {
  title: "Automatic resolution and \ninsights through AI",
  subtitle: "Network operations demo",
  text: "Attaining accuracy right from the start.",
  label: { iconPath: "start.png", text: "ILO Automations" },
  next: {
    label: "CONTINUE",
    onClick: () => setCurrentPage("ILO_213"),
    endIcon: "arrow-right",
  },
  back: {
    label: "BACK",
    onClick: () => setCurrentPage("ILO_211"),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  bgImage: "ILO/ILO2/ILO2_demo_screens_base.png",
  rightSideVideo: "ILO/ILO2/INF_CMT_827.23_Network Demo_Part 9_R1.mp4",
  pageNumber: "ILO_212",
};

export default DATA_NO_DEMO_ILO2;
